/* ADD GROUPS */
export const LIST_REPORT5 = "LIST_REPORT5"
export const LIST_REPORT5_SUCCESS = "LIST_REPORT5_SUCCESS"
export const LIST_REPORT5_CLEAN = "LIST_REPORT5_CLEAN"
export const LIST_REPORT5_ERROR = "LIST_REPORT5_ERROR"
